const ERRORS = {
  JUST_ASSIGNED_JOURNEYS: 'JUST_ASSIGNED_JOURNEYS',
  UNKNOWN: 'UNKNOWN',
};

export default ERRORS;
